import { GradeLevelChips } from "@/search/Langston/FilterPanel/filters/ReadingLevels/GradeLevelChips";
import { FilterSection } from "@/search/Langston/FilterPanel/FilterSection";
import { MaturityRangeSlider } from "./MaturityRangeSlider";

interface ReadingLevelProps {
  canSeeMaturityLevels: boolean;
}

const ReadingLevels = ({ canSeeMaturityLevels }: ReadingLevelProps) => {
  return (
    <>
      <FilterSection title="Reading levels" defaultCollapsed={false}>
        <GradeLevelChips />
        {canSeeMaturityLevels && <MaturityRangeSlider />}
      </FilterSection>
    </>
  );
};

ReadingLevels.displayName = "ReadingLevels";
export { ReadingLevels };
